class KeyCodes {
  // Control keys
  static ESC = 'Escape';
  static ENTER = 'Enter';
  static TAB = 'Tab';
  static SPACE = 'Space';
  static BACKSPACE = 'Backspace';
  static DELETE = 'Delete';

  // Modifiers (ojo: también usar event.shiftKey, etc.)
  static SHIFT_LEFT = 'ShiftLeft';
  static SHIFT_RIGHT = 'ShiftRight';
  static CTRL_LEFT = 'ControlLeft';
  static CTRL_RIGHT = 'ControlRight';
  static ALT_LEFT = 'AltLeft';
  static ALT_RIGHT = 'AltRight';
  static META_LEFT = 'MetaLeft';
  static META_RIGHT = 'MetaRight';

  // Arrows
  static ARROW_UP = 'ArrowUp';
  static ARROW_DOWN = 'ArrowDown';
  static ARROW_LEFT = 'ArrowLeft';
  static ARROW_RIGHT = 'ArrowRight';

  // Navigation
  static HOME = 'Home';
  static END = 'End';
  static PAGE_UP = 'PageUp';
  static PAGE_DOWN = 'PageDown';
  static INSERT = 'Insert';

  // Letters
  static KEY_A = 'KeyA';
  static KEY_B = 'KeyB';
  static KEY_C = 'KeyC';
  static KEY_D = 'KeyD';
  static KEY_E = 'KeyE';
  static KEY_F = 'KeyF';
  static KEY_G = 'KeyG';
  static KEY_H = 'KeyH';
  static KEY_I = 'KeyI';
  static KEY_J = 'KeyJ';
  static KEY_K = 'KeyK';
  static KEY_L = 'KeyL';
  static KEY_M = 'KeyM';
  static KEY_N = 'KeyN';
  static KEY_O = 'KeyO';
  static KEY_P = 'KeyP';
  static KEY_Q = 'KeyQ';
  static KEY_R = 'KeyR';
  static KEY_S = 'KeyS';
  static KEY_T = 'KeyT';
  static KEY_U = 'KeyU';
  static KEY_V = 'KeyV';
  static KEY_W = 'KeyW';
  static KEY_X = 'KeyX';
  static KEY_Y = 'KeyY';
  static KEY_Z = 'KeyZ';

  // Numbers (fila superior)
  static DIGIT_0 = 'Digit0';
  static DIGIT_1 = 'Digit1';
  static DIGIT_2 = 'Digit2';
  static DIGIT_3 = 'Digit3';
  static DIGIT_4 = 'Digit4';
  static DIGIT_5 = 'Digit5';
  static DIGIT_6 = 'Digit6';
  static DIGIT_7 = 'Digit7';
  static DIGIT_8 = 'Digit8';
  static DIGIT_9 = 'Digit9';

  // Numpad
  static NUMPAD_0 = 'Numpad0';
  static NUMPAD_1 = 'Numpad1';
  static NUMPAD_2 = 'Numpad2';
  static NUMPAD_3 = 'Numpad3';
  static NUMPAD_4 = 'Numpad4';
  static NUMPAD_5 = 'Numpad5';
  static NUMPAD_6 = 'Numpad6';
  static NUMPAD_7 = 'Numpad7';
  static NUMPAD_8 = 'Numpad8';
  static NUMPAD_9 = 'Numpad9';
  static NUMPAD_ADD = 'NumpadAdd';
  static NUMPAD_SUBTRACT = 'NumpadSubtract';
  static NUMPAD_MULTIPLY = 'NumpadMultiply';
  static NUMPAD_DIVIDE = 'NumpadDivide';
  static NUMPAD_DECIMAL = 'NumpadDecimal';
  static NUMPAD_ENTER = 'NumpadEnter';

  // Function keys
  static FUNC_1 = 'F1';
  static FUNC_2 = 'F2';
  static FUNC_3 = 'F3';
  static FUNC_4 = 'F4';
  static FUNC_5 = 'F5';
  static FUNC_6 = 'F6';
  static FUNC_7 = 'F7';
  static FUNC_8 = 'F8';
  static FUNC_9 = 'F9';
  static FUNC_10 = 'F10';
  static FUNC_11 = 'F11';
  static FUNC_12 = 'F12';

  // Symbols / punctuation (layout-dependent physically)
  static MINUS = 'Minus';
  static EQUAL = 'Equal';
  static BRACKET_LEFT = 'BracketLeft';
  static BRACKET_RIGHT = 'BracketRight';
  static BACKSLASH = 'Backslash';
  static SEMICOLON = 'Semicolon';
  static QUOTE = 'Quote';
  static BACKQUOTE = 'Backquote';
  static COMMA = 'Comma';
  static PERIOD = 'Period';
  static SLASH = 'Slash';

  // Misc
  static CAPS_LOCK = 'CapsLock';
  static NUM_LOCK = 'NumLock';
  static SCROLL_LOCK = 'ScrollLock';
  static PAUSE = 'Pause';
  static PRINT_SCREEN = 'PrintScreen';
}

export default KeyCodes
